import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CircularProgress from 'material-ui/CircularProgress';

import styles from './Loader.css';

export default function Loader(props) {
    return (
        <CircularProgress
            size={80}
            thickness={5}
            className={classnames(styles.loader, {
                [styles.centerX]: props.centerX,
                [styles.centerY]: props.centerY,
            })}
        />
    );
}

Loader.propTypes = {
    centerX: PropTypes.bool,
    centerY: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/UI/Loader/Loader.js